// Dashboard Data Types
export const GET_DASHBOARD_DATA_REQUEST = 'GET_DASHBOARD_DATA_REQUEST';
export const GET_DASHBOARD_DATA_SUCCESS = 'GET_DASHBOARD_DATA_SUCCESS';
export const GET_DASHBOARD_DATA_FAILURE = 'GET_DASHBOARD_DATA_FAILURE';

// Recent Stock Issues Types
export const GET_RECENT_STOCK_ISSUES_REQUEST = 'GET_RECENT_STOCK_ISSUES_REQUEST';
export const GET_RECENT_STOCK_ISSUES_SUCCESS = 'GET_RECENT_STOCK_ISSUES_SUCCESS';
export const GET_RECENT_STOCK_ISSUES_FAILURE = 'GET_RECENT_STOCK_ISSUES_FAILURE';

// Recent Stock Returns Types
export const GET_RECENT_STOCK_RETURNS_REQUEST = 'GET_RECENT_STOCK_RETURNS_REQUEST';
export const GET_RECENT_STOCK_RETURNS_SUCCESS = 'GET_RECENT_STOCK_RETURNS_SUCCESS';
export const GET_RECENT_STOCK_RETURNS_FAILURE = 'GET_RECENT_STOCK_RETURNS_FAILURE';

// Department Wise Pending Types
export const GET_DEPARTMENT_WISE_PENDING_REQUEST = 'GET_DEPARTMENT_WISE_PENDING_REQUEST';
export const GET_DEPARTMENT_WISE_PENDING_SUCCESS = 'GET_DEPARTMENT_WISE_PENDING_SUCCESS';
export const GET_DEPARTMENT_WISE_PENDING_FAILURE = 'GET_DEPARTMENT_WISE_PENDING_FAILURE';

// Department Wise Production Types
export const GET_DEPARTMENT_WISE_PRODUCTION_REQUEST = 'GET_DEPARTMENT_WISE_PRODUCTION_REQUEST';
export const GET_DEPARTMENT_WISE_PRODUCTION_SUCCESS = 'GET_DEPARTMENT_WISE_PRODUCTION_SUCCESS';
export const GET_DEPARTMENT_WISE_PRODUCTION_FAILURE = 'GET_DEPARTMENT_WISE_PRODUCTION_FAILURE';

// Filter Types
export const SET_DASHBOARD_FILTERS = 'SET_DASHBOARD_FILTERS';
export const RESET_DASHBOARD_FILTERS = 'RESET_DASHBOARD_FILTERS';

export const GET_BATCH_SUMMARY_REQUEST = 'GET_BATCH_SUMMARY_REQUEST';
export const GET_BATCH_SUMMARY_SUCCESS = 'GET_BATCH_SUMMARY_SUCCESS';
export const GET_BATCH_SUMMARY_FAILURE = 'GET_BATCH_SUMMARY_FAILURE';

export const GET_PENDING_SUMMARY_REQUEST = 'GET_PENDING_SUMMARY_REQUEST';
export const GET_PENDING_SUMMARY_SUCCESS = 'GET_PENDING_SUMMARY_SUCCESS';
export const GET_PENDING_SUMMARY_FAILURE = 'GET_PENDING_SUMMARY_FAILURE'; 